import type { OrderStatus } from "@/types/tms";

/**
 * Keeps the parent and its leg rows in the same lifecycle state when the edit
 * flow promotes a multi-leg order from booked to confirmed.
 *
 * External trips are created as booked/unplanned, so their read-side status
 * cannot stand in for the local confirmation write.
 */
export function legDriverStatusForOrderEdit(
  persistedDriverStatus: OrderStatus | null | undefined,
  isMultiLegPromotion: boolean,
): OrderStatus | null {
  return isMultiLegPromotion ? "confirmed" : persistedDriverStatus ?? null;
}